<template>
  <div id="loginEntrance">

    <div class="loginEntrance-header">
      <img src="../../../assets/icon/close2.png" class="loginEntrance-header-close" @click="close"/>
      <router-link to="/register" slot="right">
        <span class="loginEntrance-header-register">注册</span>
      </router-link>

    </div>

    <div class="loginEntrance-content">
      <img src="../../../assets/icon/login_img.jpg" class="loginEntrance-content-img"/>
    </div>

    <div class="loginEntrance-footer">
      <router-link to="/login" slot="right" :replace="true">
        <div class="loginEntrance-footer-login">手机号登录</div>
      </router-link>

    </div>


  </div>
</template>

<script>

  import bus from '../../../js/eventBus'
  export default {
    name: 'mineLogin',
    mounted () {
    },
    destroyed () {
    },
    computed: {
    },
    methods: {
      close () {
//        console.log(document.getElementsByClassName('mint-tabbar')[0].style.display)
        this.$router.push('/')
      }
    }
  }
</script>



<style lang="scss">
  @import '../../../assets/css/mixin';


  .loginEntrance {
    background-color: white;
  }
  #mineLogin {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: white;
  }

  .loginEntrance-header {
    /*height: pxToRem(100px);*/
    height: 7.49%;
    position: fixed;
    top:0;
    left: pxToRem(30px);
    right: pxToRem(30px);
    background-color: white;

    display: flex;
    justify-content: space-between;
    align-items: center;

  }
  .loginEntrance-header-close {
    width: pxToRem(20px);
  }
  .loginEntrance-header-register {
    font-size: pxToRem(24px);
  }

  .loginEntrance-content-img {
    width: 100%;
    /*overflow: auto;*/
  }


  .loginEntrance-content {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;

    background-color: white;
    position: fixed;
    bottom: 16.79%;
    top: 7.49%;
    left: pxToRem(30px);
    right: pxToRem(30px);
  }


  .loginEntrance-footer {
    height: 16.79%;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
  }

  .loginEntrance-footer-login {
    height: pxToRem(100px);
    width: pxToRem(690px);
    background: #3D2D23;
    color: white;

    text-align: center;
    line-height: pxToRem(100px);
    font-size: pxToRem(28px);
  }

</style>


// WEBPACK FOOTER //
// loginEntrance.vue?6db7c79f